import { formatMomentShort } from 'utils/date'

export const getDelayTooltip = (translate: (key: string) => string, date: string): string =>
  `${translate('transport_plan-delay_helper_tooltip')}\n${formatMomentShort(date)}`
